// extracted by mini-css-extract-plugin
export default {"rate_text":"RatingSingleProduct_rate_text__gHDnN","rating_container":"RatingSingleProduct_rating_container__kwXTS"};